import { Locale } from 'date-fns';
import { enUS, kk, ru, uz } from 'date-fns/locale';

import type { SupportedLang } from 'app/lang';

// TODO: создать локали для ky, tg - можно даже ПР кинуть в эту либу :)


export const DATE_FNS_LOCALE: Record<SupportedLang, Locale> = {
  ru,
  kk,
  en: enUS,
  uz,
  // TODO: создать локали для:
  ky: ru,
  tg: enUS,
};
